"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _password_hide_icon = require("../../../atoms/icons/password_hide_icon");
var _password_visible_icon = require("../../../atoms/icons/password_visible_icon");
var _text_input = require("../../text_input");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var ConfirmPasswordInput = function ConfirmPasswordInput(_ref) {
  var register = _ref.register,
    errors = _ref.errors,
    passwordInputValue = _ref.passwordInputValue;
  var error = false;
  var helperText = '';
  if (errors.passwordConfirmation) {
    error = true;
    helperText = errors.passwordConfirmation.message;
  }
  var checkPassword = function checkPassword(confirmPasswordValue) {
    if (passwordInputValue === confirmPasswordValue) {
      return true;
    } else {
      return 'Please enter the same Password again.';
    }
  };
  var _useState = (0, _react.useState)('password'),
    _useState2 = _slicedToArray(_useState, 2),
    inputType = _useState2[0],
    setInputType = _useState2[1];
  var handleIconClick = function handleIconClick() {
    if (inputType === 'password') {
      setInputType('text');
    } else {
      setInputType('password');
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_text_input.TextInput, {
    type: inputType,
    label: "Confirm Password",
    name: "passwordConfirmation",
    helperText: helperText,
    error: error,
    register: register({
      required: 'Please confirm your password',
      validate: {
        samePassword: function samePassword(value) {
          return checkPassword(value);
        }
      }
    }),
    cypressClass: "password-confirmation",
    icon: inputType === 'password' ? /*#__PURE__*/_react["default"].createElement(_password_hide_icon.PasswordHideIcon, null) : /*#__PURE__*/_react["default"].createElement(_password_visible_icon.PasswordVisibleIcon, null),
    onIconClick: handleIconClick
  }));
};
ConfirmPasswordInput.propTypes = {
  /**
   * Object containing the errors from this input field.
   */
  errors: _propTypes["default"].object,
  /**
   *
   * The password value to check against for validation when confirming password
   */
  passwordInputValue: _propTypes["default"].string,
  /**
   * A function that gets passed for the useForm hook from react-hook-form to register an input
   *
   */
  register: _propTypes["default"].func.isRequired
};
ConfirmPasswordInput.defaultProps = {
  errors: {},
  passwordInputValue: '',
  register: function register() {}
};
var _default = exports["default"] = ConfirmPasswordInput;